import { Card, Col, Form, Input, Row, Select } from 'antd';
import FloatingFormItem from '../../FloatingFormItem';
import { VehicleFormData } from '@/core/domain/people/CustomerVehicles/CustomerVehicles.types';
import InputText from '../../InputText';
import MaskedInput from 'react-text-mask';
import { useDefaultMaxLengthFieldError } from '@/hooks';

interface Props {
  disabledFields?: boolean;
}

export default function VehicleEngineDataForm({
  disabledFields = false,
}: Props) {
  const form = Form.useFormInstance<VehicleFormData>();
  const formValues = Form.useWatch([], form);
  const searchBy = Form.useWatch('searchBy', form);

  const defaultMaxLenghtFieldError = useDefaultMaxLengthFieldError();

  const hasLicensePlate = !!formValues?.licensePlate;
  const hasChassi = !!formValues?.chassi && formValues.chassi.length === 17;

  const handlerDisableFields =
    searchBy === 'Placa' ? !hasLicensePlate : !hasChassi;

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { key } = event;

    if (
      !/^\d$/.test(key) &&
      key !== 'Backspace' &&
      key !== 'Enter' &&
      key !== ','
    ) {
      event.preventDefault();
    }
  };

  const valveOptions = Array.from({ length: 16 }, (_, i) => `${(i + 1) * 2}V`);

  return (
    <Card title="Dados do Motor">
      <Row gutter={[12, 12]}>
        <Col span={24} md={8} lg={4}>
          <FloatingFormItem
            name="engineCapacity"
            label="Cilindrada"
            rules={[
              defaultMaxLenghtFieldError(10),
              {
                validator: (_, value) => {
                  const isValid = /^\d\.\d$/.test(value) || !value;
                  return isValid
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(
                          "Formato inválido. Use o formato 'X.Y', como '1.0'",
                        ),
                      );
                },
              },
            ]}
          >
            <MaskedInput
              disabled={disabledFields || handlerDisableFields}
              className="ant-input"
              mask={[/\d/, '.', /\d/]}
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={4}>
          <FloatingFormItem
            name="valves"
            label="Nº de Válvulas"
            rules={[defaultMaxLenghtFieldError(5)]}
          >
            <Select
              disabled={disabledFields || handlerDisableFields}
              style={{ width: '100%' }}
              options={valveOptions.map((value) => ({ value, label: value }))}
              allowClear
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={4}>
          <FloatingFormItem
            name="cylinders"
            label="Nº de Cilindros"
            rules={[defaultMaxLenghtFieldError(5)]}
          >
            <InputText
              disabled={disabledFields || handlerDisableFields}
              onlyNumber
            />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={4}>
          <FloatingFormItem
            name="engineName"
            label="Nome do Motor"
            rules={[defaultMaxLenghtFieldError(50)]}
          >
            <Input disabled={disabledFields || handlerDisableFields} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={4}>
          <FloatingFormItem
            name="engineTechnicalCode"
            label="Código do Motor"
            rules={[defaultMaxLenghtFieldError(50)]}
          >
            <Input disabled={disabledFields || handlerDisableFields} />
          </FloatingFormItem>
        </Col>

        <Col span={24} md={8} lg={4}>
          <FloatingFormItem name="horsePower" label="Potência CV">
            <Select
              mode="tags"
              maxTagCount="responsive"
              style={{ width: '100%' }}
              disabled={disabledFields || handlerDisableFields}
              onInputKeyDown={handleKeyDown}
            />
          </FloatingFormItem>
        </Col>
      </Row>
    </Card>
  );
}
